import { EventBus } from '@/plugins/event-bus'

const moduleState = {
  stockcars: [],
  isLoading: false,
  matchingStockCars: {
    resultsCountry: [],
    resultsDealer: [],
  },
  bestMatchingStockCars: {
    resultsCountry: [],
    resultsDealer: [],
  },
}

const getters = {
  stockcars: (state) => state.stockcars,
}

const mutations = {
  /* eslint-disable no-param-reassign */
  setStockCars: (state, payload) => {
    state.stockcars = payload
    EventBus.$emit('stockcars/stockcars')
  },
  resetStockCars: (state) => {
    state.stockcars = []
    EventBus.$emit('stockcars/stockcars')
  },
  setBestMatchingStockCars: (state, payload) => {
    state.bestMatchingStockCars.resultsCountry = payload.ResultsCountry || []
    state.bestMatchingStockCars.resultsDealer = payload.ResultsDealer || []
  },
  setMatchingStockCars: (state, payload) => {
    state.matchingStockCars.resultsCountry = payload.ResultsCountry || []
    state.matchingStockCars.resultsDealer = payload.ResultsDealer || []
  },
}

const actions = {
  async reset({ commit }) {
    commit('resetStockCars')
  },
  async addStockCars({ commit, state }, payload) {
    let noDuplicates = []

    payload.forEach((element) => {
      if (!state.stockcars.some((x) => x.Id == element.Id)) noDuplicates.push(element)
    })

    let concatted = state.stockcars.concat(noDuplicates)
    commit('setStockCars', concatted)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
